import { Loadable } from '@gdp/react-app/lib/helpers/loadable';

export const LoadableItemRoutes = Loadable(
  './ItemRoutes',
  () => import(/* webpackChunkName: "Item" */ './ItemRoutes'),
  () => [(require as any).resolveWeak('./ItemRoutes')]
);
